import { useState, useCallback } from 'react';
import { safeLocalStorage } from './safeStorage';

const useOnboardingDialog = (id: string) => {
  const localStorageKey = `onboarding-${id}`;
  const localStorageDateKey = `onboarding-${id}-date`;

  const [isShown, setIsShown] = useState(() => {
    return safeLocalStorage.getItem(localStorageKey) === 'true';
  });

  const markDialogAsSeen = useCallback(() => {
    safeLocalStorage.setItem(localStorageKey, 'true');
    safeLocalStorage.setItem(localStorageDateKey, Date.now().toString());
    setIsShown(true);
  }, [localStorageKey, localStorageDateKey]);

  return { isShown, markDialogAsSeen };
};

export default useOnboardingDialog;
